<template>
  <div class="wrap">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .wrap {
    --wrap-max-width: 1260px;
    --wrap-min-width: 950px;
    --wrap-offset: 20px;

    width: 100%;
    min-width: var(--wrap-min-width);
    max-width: var(--wrap-max-width);
    padding: 0 var(--wrap-offset);
    margin-right: auto;
    margin-left: auto;

    @include legacy-adaptivity.tablet {
      --wrap-max-width: 100%;
      --wrap-min-width: 100%;

      box-sizing: border-box;
    }
  }
</style>
